import { ensureLoggedOut } from '@/state/Authentication'
import store from '../store/store'

export function injectCart({ cartId, orderId }: { cartId?: string; orderId?: string }): Promise<any> | void {
  if (cartId) {
    return ensureLoggedOut().then(() => store.dispatch('Cart/inject', cartId))
  }

  if (orderId) {
    return ensureLoggedOut().then(() => store.dispatch('Cart/injectOrder', orderId))
  }
}
